import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { parsePCXAxisOption, parseXAxisInterval, parseXAxisLine } from '../component/xAxis';
import {
  parseBarGap,
  judgeIsNormalBar,
  parseBarSize,
  parseBarColor
} from '../../mobile/series/bar';
import { parseGrid } from '../component/grid';
import { yAxisThemeParse } from '../component/yAxis';
import { dataZoomThemeParse } from '../component/dataZoom';
import { ExtendBarSeries } from '../../../core/option';

function parseBarFocus(barSeries: ExtendBarSeries[]) {
  const defaultEmphasisStyle = {
    focus: 'series'
  };
  barSeries.forEach(item => {
    item.emphasis = util.merge(item.emphasis || {}, defaultEmphasisStyle);
  });
}

export function pcBarThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  if (!judgeIsNormalBar(option)) {
    return;
  }
  const barSeries = option.series.filter(item => item.type === 'bar');
  if (barSeries.length === 0) {
    return;
  }

  parseBarSize(barSeries);
  parseBarGap(barSeries);
  parseBarColor(barSeries);
  parseBarFocus(barSeries);

  parseGrid(option);
  dataZoomThemeParse(option, chart);
  parseXAxisLine(option);
  parsePCXAxisOption(option, chart);
  yAxisThemeParse(...args);
  parseXAxisInterval(...args);
}
